import React from 'react';
/* Components */
import Slider from './slider/Slider';
import Modal from '../common/modal/modal';
import {connect} from 'react-redux';
import {changeHelpIntroData} from '../../store/tooltips/actions';

export class Onboarding extends React.PureComponent {
  handleCloseModal = () => this.props.changeHelpIntroData(true);

  render() {
    return (
      <>
        <Modal.Default isOpen={!this.props.isHelpIntroDisabled} customClass="glu-slider-modal">
          <Slider closeModal={this.handleCloseModal} />
        </Modal.Default>
      </>
    );
  }
}

const mapStateToProps = ({tooltipsReducer: {isHelpIntroDisabled}}) => ({
  isHelpIntroDisabled,
});

const mapDispatchToProps = (dispatch) => ({
  changeHelpIntroData: (data) => changeHelpIntroData(dispatch, data),
});

export default connect(mapStateToProps, mapDispatchToProps)(Onboarding);
